module.exports = __webpack_public_path__ + "static/media/img_retirement.7b368d2b.jpg";